import React from 'react';
import styled from '@emotion/styled';
import { TextCollapsible } from '../../../components/TextCollapsible/TextCollapsible';
import { __ } from '../../../helpers/TranslationService';
import { CruisePageSectionHeader } from '../components/SectionHeader/SectionHeader';

const Wrapper = styled.div`
    max-width: 1150px;
    margin: 0 auto;
    font-size: 14px;
`;

export const LegalText = (props: { isMobile: boolean; cancellationFeesDescription: string }) => {
    const [isOpen, toogleState] = React.useState(false);

    if (!props.cancellationFeesDescription) {
        return null;
    }

    const toogleStateOpen = (isOpen) => {
        toogleState(isOpen);
    };

    const stylesOverride = isOpen ? { height: 'auto' } : { height: '120px', overflow: 'hidden' };

    return (
        <Wrapper>
            {!props.isMobile && (
                <CruisePageSectionHeader>
                    {__('additionalInformation', 'dreamlines')}
                </CruisePageSectionHeader>
            )}

            <div className="cruisePageSectionContainer">
                <div
                    style={!props.isMobile ? stylesOverride : undefined}
                    dangerouslySetInnerHTML={{ __html: props.cancellationFeesDescription }}
                />

                {!props.isMobile && (
                    <TextCollapsible isOpen={isOpen} toogleStateOpen={toogleStateOpen} />
                )}
            </div>
        </Wrapper>
    );
};
